import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import SectionForm from "./SectionForm";
import { ISection } from "../../../model/formconfiguration/Section";
import { Button, Row, Col } from "antd";

export interface State {}

export interface UpdateSectionFormProps extends FormComponentProps {
  translate: any;
  registerFormSubmitEventHandler?: any;
  section: ISection;
  updateFormSection: any;
  Actions: any;
  readOnly: boolean;
}

class UpdateSectionForm extends React.Component<UpdateSectionFormProps, State> {
  private handleOnChangeEvent = (e) => {
    const { section, updateFormSection } = this.props;
    let updatedFormSection = section;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        Object.assign(updatedFormSection, values);
        updateFormSection(updatedFormSection);
      }
    });
  };

  render() {
    const { translate, section, Actions, readOnly } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <React.Fragment>
        {!readOnly && (
          <Row gutter={2} type="flex" justify="end">
            <Col>{Actions}</Col>
            <Col>
              <Button type="primary" onClick={this.handleOnChangeEvent}>
                {translate("qualifier_form.apply_changes")}
              </Button>
            </Col>
          </Row>
        )}
        <SectionForm
          getFieldDecorator={getFieldDecorator}
          translate={translate}
          section={section}
          readOnly={readOnly}
        ></SectionForm>
      </React.Fragment>
    );
  }
}

export default UpdateSectionForm;
